import { postRequest, request } from '../../../utils'
import { BackupTransactionType } from '../enums/backupTransationType'

interface ExportBackupParams {
  organizationId: string
  period?: string
  types: BackupTransactionType
}

interface ExportBackupPayload {
  period?: string
  types?: BackupTransactionType[]
}

export const exportBackup = async ({ organizationId, period, types }: ExportBackupParams): Promise<void> => {
  const payload: ExportBackupPayload = {}

  if (types !== BackupTransactionType.All) {
    payload.types = [types]
  }

  if (period) {
    payload.period = period
  }

  return await request(
    `/organizations/${organizationId}/exports/backup`,
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
    {
      returnRawResponse: true,
      withAuth: true,
    },
  )
}

interface ExportFecReportParams {
  fromDate: string
  organizationId: string
  toDate: string
}

export const exportFecReport = ({ fromDate, organizationId, toDate }: ExportFecReportParams) => {
  return postRequest('/v2/fecExports', {
    fecExport: {
      organizationId,
      fromDate,
      toDate,
    },
  })
}
